/**
 * TCM has four separate apps in one web client. Which one you get is decided by the
 * role on your account, never by a switcher in the UI.
 */
export type Audience = 'owner' | 'student' | 'parent' | 'internal';

export const AUDIENCES: readonly Audience[] = ['owner', 'student', 'parent', 'internal'];

export const AUDIENCE_HOME: Record<Audience, string> = {
  owner: '/app',
  student: '/student',
  parent: '/parent',
  internal: '/internal',
};

export const AUDIENCE_LOGIN: Record<Audience, string> = {
  owner: '/login/owner',
  student: '/login/student',
  parent: '/login/parent',
  internal: '/login/team',
};

export const AUDIENCE_LABEL: Record<Audience, string> = {
  owner: 'Center owner',
  student: 'Student',
  parent: 'Parent',
  internal: 'TCM team',
};

const ROLE_AUDIENCE: Record<string, Audience> = {
  OWNER: 'owner',
  MANAGER: 'owner',
  STAFF: 'owner',
  STUDENT: 'student',
  PARENT: 'parent',
  SUPER_ADMIN: 'internal',
  PLATFORM_ADMIN: 'internal',
  PLATFORM_SUPPORT: 'internal',
};

export function audienceForRole(role: string | null | undefined): Audience | null {
  return (role && ROLE_AUDIENCE[role]) || null;
}

const ROLE_LABEL: Record<string, string> = {
  OWNER: 'Owner',
  MANAGER: 'Manager',
  STAFF: 'Staff',
  STUDENT: 'Student',
  PARENT: 'Parent',
  SUPER_ADMIN: 'Platform admin',
  PLATFORM_ADMIN: 'Platform admin',
  PLATFORM_SUPPORT: 'Support',
};

export function roleLabel(role: string | null | undefined): string {
  return (role && ROLE_LABEL[role]) || 'User';
}
